const API_PATHS = {
  CONTACT_US: {
    GET_CONTACT_DETAILS: "/api/appPreference/byPrefKeys",
  },
  MY_PROFILE: {
    GET_MY_PROFILE: "/api/userProfile/myProfile",
    SAVE_YOUR_PREFERENCES: "/api/userProfile/setUserPreference",
    GET_YOUR_PREFERENCES: "/api/userProfile/getUserPreference",
  },
  HOME_PAGE: {
    GET_HOME_PAGE: "/api/mortgage/myHomeMortgage",
    GET_YOUR_TO_DO_LISTS: "/api/document/getYourToDoLists",
    GET_YOUR_TO_DO_LISTS_PREFERENCES:
      "/api/userProfile/getUserPreferenceStatus",
  },
  MY_MORTGAGE: {
    GET_MY_MORTGAGE: "/api/mortgage/myMortgage",
  },

  MY_DOCUMENTS: {
    GET_MY_DOCUMENTS: "api/document/getMortgageDocuments",
    DOWNLOADS_MY_DOCUMENT: "api/document/getDocumentById",
    VIEW_MY_DOCUMENT: "api/document/viewDocumentById",
  },
  USER: {
    VALIDATE_USER: "/api/validate-user",
  },
  AUDIT_LOGGING: {
    AUDIT_LOGGING: "/api/audit/logout",
  },
};

export default API_PATHS;
